import { ACTIONS } from "../../lib/admin";

const when = (iso) =>
  new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

const device = (ua = "") => {
  const m = ua.match(/Android [\d.]+(; [^;)]+)?/);
  if (m) return m[0].replace(/; /, " · ");
  if (/iPhone/.test(ua)) return "iPhone";
  return ua ? "Outro" : "—";
};

export const RecentTable = ({ items }) => {
  const rows = Array.isArray(items) ? items : [];
  return (
    <div className="ad-card p-5" data-testid="recent-clicks">
      <h2 className="ad-h2">Últimos cliques</h2>
      {rows.length === 0 ? (
        <p className="text-sm text-[#9DB0A5] py-10 text-center">Nenhum clique ainda.</p>
      ) : (
        <ul className="mt-3 divide-y divide-[#22352B]">
          {rows.map((r) => (
            <li key={r.id} data-testid={`recent-row-${r.id}`} className="flex items-center gap-3 py-3">
              <span className="ad-pill" style={{ color: ACTIONS[r.action]?.color, borderColor: ACTIONS[r.action]?.color }}>
                {ACTIONS[r.action]?.label ?? r.action}
              </span>
              <span className="flex-1 min-w-0 text-[13px] text-[#C9D6CE] truncate">{device(r.user_agent)}</span>
              <span className="text-[12.5px] text-[#9DB0A5] tabular-nums shrink-0">{when(r.created_at)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
